import { Component } from "react";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import Footerwithdr from "../../../../common_components/Footerwithdr";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import {
  primaryChapterListActionId,
  toastError,
  toastSuccess,
} from "../../../../utils/constants";
import Pagination from "../../../../utils/pagination";
import moment from "moment";
import { fill_action } from "../../../../actions/fillCombo_action";

const breadcrumbCSS = `
/* Breadcrumb styles */
.breadcrumb {
  padding: 0;
  margin: 0;
  list-style: none;
  color:black;
}
.breadcrumb-item::before {
    content:"" !important;
}
.breadcrumb-item {
  display: inline-block;
  margin-right: -10px;
  font-size: 14px;
}

/* Style for the right angle icon */
.breadcrumb-item .fa-angle-double-right {
  margin: 0 10px;
}

`;

class masterChapterList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      UserID: "",
      ExhibitionID: "",
      ReceiptID: "",
      AccountID: "",
      primaryChapterListData: [],
      level0: [],
      level2: [],
      level3: [],
      level4: [],
    };
    this.getFillList = this.getFillList.bind(this);
  }
  componentDidMount() {
    this.getFillList(
      primaryChapterListActionId,
      sessionStorage.getItem("sessionExhibitionID"),
      "",
      "",
      "",
      sessionStorage.getItem("sessionExhRegistrationID")
    );
  }
  getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
    const {
      level3,
      level4,
      level2,
      level0,
      is_update,
      PrimaryChapterId,
      primaryChapterRadio,
      stallAreaId,
    } = this.state;
    if (!is_update) {
      this.setState({ isLoading: true });
    }

    this.props
      .fill_action(
        actionID,
        exhibitionID,
        moduleID,
        keyValue,
        value,
        sessionStorage.getItem("sessionExhRegistrationID")
      )
      .then((data) => {
        if (data.error != 1) {
          // country list
          if (actionID === primaryChapterListActionId) {
            console.log("primaryChapterListActionId 121212");
            for (var i = 0; i < data.data["level2"].length; i++) {
              data.data["level2"][i].isHighlight = false;
            }
            this.setState({
              primaryChapterListData: data.data["primaryChapter"],
              level0: data.data["level0"],
              level2: data.data["level2"],
              level3: data.data["level3"],
              level4: data.data["level4"],
              isLoading: false,
            });
            if (is_update) {
              // this.setState({
              //     primaryChapterRadio: primaryChapterRadio
              //     // primaryChapterRadio : data.data[0]['PrimaryChapter']
              // })

              if (primaryChapterRadio != "") {
                for (var i = 0; i < data.data["primaryChapter"].length; i++) {
                  if (
                    data.data["primaryChapter"][i].ChapterID ==
                    primaryChapterRadio
                  ) {
                    data.data["primaryChapter"][i].isChecked = true;
                  } else {
                    data.data["primaryChapter"][i].isChecked = false;
                  }
                }
                this.setState({
                  primaryChapterListData: data.data["primaryChapter"],
                });
              }

              var lev2List = [...data.data["level2"]];
              for (var i = 0; i < lev2List.length; i++) {
                if (lev2List[i].ParentChapterID == primaryChapterRadio) {
                  lev2List[i]["isHighlight"] = true;
                } else {
                  lev2List[i]["isHighlight"] = false;
                }
              }
              this.setState({
                level2: lev2List,
              });

              var list = [];
              // console.log("level2 get", level2)
              data.data["level2"].length > 0 &&
                data.data["level2"].map((level2Data) => {
                  if (level2Data.IsSelect && level2Data.IsCheckbox) {
                    // console.log("level2Data get", level2Data)

                    list.push(level2Data);
                  }
                });
              data.data["level3"].length > 0 &&
                data.data["level3"].map((level3Data) => {
                  if (level3Data.IsSelect && level3Data.IsCheckbox) {
                    list.push(level3Data);
                  }
                });
              data.data["level4"].length > 0 &&
                data.data["level4"].map((level4Data) => {
                  if (level4Data.IsSelect && level4Data.IsCheckbox) {
                    list.push(level4Data);
                  }
                });
              list.sort((a, b) => (a.ChapterID > b.ChapterID ? 1 : -1));
              data.data["level0"].length > 0 &&
                data.data["level0"].map((level0Data) => {
                  if (level0Data.IsSelect) {
                    // console.log("level2Data get", level2Data)

                    list.push(level0Data);
                  }
                });
              // console.log("exhibitDetailsList get", list)
              this.setState({ exhibitDetailsList: list });
            }
            setTimeout(() => {
              this.filterLevelData();
            }, 300);
          }
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  filterLevelData() {
    const { level2, level3, level4 } = this.state;
    var newLevel = [...level2];
    for (var i = 0; i < level3.length; i++) {
      var tempLevel4 = [];
      for (var j = 0; j < level4.length; j++) {
        if (level3[i]["ChapterID"] == level4[j]["ParentChapterID"]) {
          tempLevel4.push(level4[j]);
        }
      }
      level3[i]["level_four_List"] = tempLevel4;
      // console.log(" level3[i]['level_four_List']", tempLevel4);
    }

    for (var i = 0; i < newLevel.length; i++) {
      var tempLevel3 = [];
      for (var j = 0; j < level3.length; j++) {
        if (newLevel[i]["ChapterID"] == level3[j]["ParentChapterID"]) {
          tempLevel3.push(level3[j]);
        }
      }
      newLevel[i]["level_third_List"] = tempLevel3;
      // console.log("level2[i]['level_third_List']", tempLevel3);
    }

    ///////////============
    console.log("level2", newLevel);
    this.setState({ level2: newLevel });
  }


  render() {
    const {
      isLoading,
      primaryChapterListData,
      level0,
      level2,
      level3,
      level4,
    } = this.state;
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        <HeaderWithLogo />
        <style type="text/css">{breadcrumbCSS}</style>

        <>
          <AdminDrawer />
          <div
            className={
              JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1
                ? "with-dr-container"
                : "with-dr-container com-height"
            }
          >
            <div className="main-content app-content mt-0">
              <div className="container-fluid">
                <div className="row">
                  <div className="step-name">
                    <p>Chapters</p>
                  </div>
                </div>
                <div style={{ marginTop: 10 }}>
                  <div className="row mb-4">
                    <div className="chap-name-list mt-3 d-flex justify-content-left">
                      <ul className="breadcrumb">
                        <li className="breadcrumb-item">
                          List of Primary Chapter
                        </li>
                        <li className="breadcrumb-item chap-name-list-link text-primary">
                          <i
                            className="fa fa-angle-double-right"
                            aria-hidden="true"
                          ></i>
                          Chapter
                        </li>
                        <li className="breadcrumb-item chap-name-list-link text-primary">
                          <i
                            className="fa fa-angle-double-right"
                            aria-hidden="true"
                          ></i>
                          Sub Chapter
                        </li>
                        <li className="breadcrumb-item chap-name-list-link text-primary">
                          <i
                            className="fa fa-angle-double-right"
                            aria-hidden="true"
                          ></i>
                          Product
                        </li>
                      </ul>
                    </div>

                    <div
                      className="table-responsive mt-2"
                      style={{ width: 600, marginBottom: 25 }}
                    >
                      <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-3">
                        <thead>
                          <tr>
                            <th className="text-center" style={{ width: 100 }}>
                              Sr.No
                            </th>
                            <th>Name</th>
                          </tr>
                        </thead>
                        <tbody>
                          {primaryChapterListData.length > 0
                            ? primaryChapterListData.map((data, i) => (
                                <tr key={i}>
                                  <td className="text-center">{i + 1}</td>
                                  <td onClick={() => this.iterateToL2(data.ChapterID)}>
                                    {data.ChapterName}
                                  </td>
                                </tr>
                              ))
                            : null}
                            {level2.length > 0
                            ? level2.map((data, i) => (
                                <tr key={i}>
                                  <td className="text-center">{i + 1}</td>
                                  <td onClick={() => this.iterateToL3(data.ChapterID)}>
                                    {data.ChapterName}
                                  </td>
                                </tr>
                              ))
                            : null}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID != 1 && (
            <Footerwithdr />
          )}
        </>
      </>
    );
  }
}
export default withRouter(connect(null, { fill_action })(masterChapterList));
